import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const CustomGrid = styled(Grid)(() => ({
  // Please add a new class if you want to add something new
  '&.default-padding': {
    paddingTop: '20px',
  },

  '&.first-item': {
    paddingTop: '0px',
  },
}));

function GridContainer({
  children = null,
  defaultStyles = 'version-1',
  className = '',
  ...props
}) {
  const newClassName = useMemo(() => {
    if (defaultStyles === 'version-1') {
      return `default-padding ${className || ''}`;
    }

    return className || '';
  }, [defaultStyles, className]);

  return (
    <CustomGrid
      className={newClassName}
      container
      {...props}
    >
      {children}
    </CustomGrid>
  );
}

GridContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  defaultStyles: PropTypes.oneOf(['version-1', '']),
};

export default GridContainer;
